var getSearchType = function getSearchType(isSearchPage) {
  var type;

  if (isSearchPage) {
    var _searchType$;

    var searchType = window.location.href.match(/t=([a-zA-Z]+)?/);
    type = searchType === null || searchType === void 0 ? void 0 : (_searchType$ = searchType[1]) === null || _searchType$ === void 0 ? void 0 : _searchType$.toUpperCase();
  }

  return type;
};

export { getSearchType };
